(function () {
  const topics = document.querySelectorAll('.questionsAndAnswers__topic');

  for (const topic of topics) {
    const question = topic.querySelector('.questionsAndAnswers__question');
    const answer = topic.querySelector('.questionsAndAnswers__answer');
    answer.style.height = topic.classList.contains('active')
      ? answer.scrollHeight + 'px'
      : 0;

    question.addEventListener('click', () => {
      if (topic.classList.contains('active')) {
        topic.classList.remove('active');
        answer.style.height = 0;
      } else {
        const activeTopic = document.querySelector(
          '.questionsAndAnswers__topic.active'
        );
        if (activeTopic) {
          activeTopic.classList.remove('active');
          activeTopic.querySelector(
            '.questionsAndAnswers__answer'
          ).style.height = 0;
        }
        topic.classList.add('active');
        answer.style.height = answer.scrollHeight + 'px';
      }
    });
  }
})();
